/**
 * Used for setting the instance of InsightsApi, so that components
 * with automatic analytics can access it, and send events through it.
 */
class AnalyticsManager {
    /**
     * Returns the set insightsApi instance, or null if it wasn't set.
     */
    static getInsightsApi() {
        return this.insightsApi;
    }
    /**
     * Planners should call this method as early as possible, before rendering
     * any components which have automatic analytics enabled.
     *
     * @param insightsApi The insightsApi instance created by the planner.
     */
    static setInsightsApi(insightsApi) {
        this.insightsApi = insightsApi;
    }
}
AnalyticsManager.insightsApi = null;
export default AnalyticsManager;
//# sourceMappingURL=AnalyticsManager.js.map